// best practice: stay out of the global scope
!(function () {
  // create a div (could also reuse a known element)
  var el = document.createElement('div');
  // detect support
  var supports_grid = typeof el.style.grid === 'string';
  // add the class to the body
  if(!supports_grid)
    document.querySelector('body').classList.add("grid-ko");
  else
    document.querySelector('body').classList.add("grid-ok");
})();